import React from 'react'

import { NumericFormat, NumericFormatProps } from 'react-number-format'

import { TextField, TextFieldProps } from '../'
import { Formatter } from './formatter'

export type NumberFormatProps = Omit<NumericFormatProps, 'onChange'> &
  Omit<TextFieldProps, 'type' | 'onChange'> & {
    ref?: React.Ref<any>
    onChange?: (value: any) => void
    value?: number | string
    formatter?: Formatter
  }

const defaultFormatter: Formatter = {
  toDisplay: (value: string) => Number(value),
  toActual: (value: string) => Number(value),
}

const NumberFormat: React.FC<NumberFormatProps> = ({
  value,
  onChange,
  formatter = defaultFormatter,
  defaultValue,
  name,
  thousandSeparator = true,
  ...props
}) => {
  return (
    <NumericFormat
      customInput={TextField}
      value={formatter.toDisplay(value)}
      onValueChange={({ floatValue }) => {
        if (floatValue !== value) {
          onChange?.(formatter.toActual(floatValue))
        }
      }}
      name={name}
      defaultValue={defaultValue}
      thousandSeparator={thousandSeparator}
      {...props}
    />
  )
}

export { NumberFormat }
